export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-rewind-ten-6a5fc523b9e50348e0f6b833e9fd03f9.svg";